module.exports = __webpack_public_path__ + "static/media/test11_3.ea82429c.png";